module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iyqJp"))).then(() => parcelRequire('d0iPb'));